import { EmptyStepIcon } from '../../../../assets';
import { validationsMessages } from 'lib';
import * as yup from 'yup';

export interface CreateStepFormData {
    name: string;
    description: string;
}

export const CreateStepSchema = yup.object({
    name: yup.string().required(validationsMessages.required),
    description: yup.string().optional(),
});

export const CreateStepDefaults = {
    name: '',
    description: '',
};

export const createStepConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'step-details': {
        imgSrc: EmptyStepIcon,
        headingText: 'Step Details',
        iconStyles: { display: 'none' },
    },
};

export const checkForDuplicateStepName = (steps: any[], step: any): boolean => {
    return steps.some(
        (ele: any) => ele.name === step.name && ele.id !== step.id
    );
};

export const stepFormStyles = {
    formFeatureNextButtonStyles: {
        mt: 2.5,
        '& .MuiButtonBase-root': {
            height: '42px !important',
            width: '130px',
        },
    },
    formHeadingText: {
        mt: 4.03125,
        '& .MuiTypography-root': {
            fontWeight: '600',
            fontSize: '28px',
        },
    },
};
